import { render, staticRenderFns } from "./Dialog_Signature.vue?vue&type=template&id=187b615e&"
import script from "./Dialog_Signature.vue?vue&type=script&lang=js&"
export * from "./Dialog_Signature.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_Signature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports